import httpManager from "@/app/shared/utils/httpManager";
import { TABLE_PAGE_SIZE_XL } from "../../../shared/utils/constants";
export default async function (params, pagination = {}) {
  let query = "";
  query += params.entity ? `entity=${params.entity}&` : "";
  query += params.portfolio ? `portfolio=${params.portfolio}&` : "";
  query += params.queue ? `queue=${params.queue}&` : "";
  query += params.startValue ? `start_date=${params.startValue}:00&` : "";
  query += params.endValue ? `end_date=${params.endValue}:59` : "";

  const offset = (pagination.current - 1 || 0) * TABLE_PAGE_SIZE_XL;
  const pageSize = pagination.pageSize || TABLE_PAGE_SIZE_XL;

  const url = `/reports/30/?offset=${offset}&limit=${pageSize}&${query}`;
  const response = await httpManager.get(url);
  return response?.data;
}
